import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-account-details-dialog',
  templateUrl: './account-details-dialog.component.html',
  styleUrls: ['./account-details-dialog.component.scss']
})
export class AccountDetailsDialogComponent implements OnInit {
  @Input() showAccount: boolean;
  @Output() displayChange = new EventEmitter();
  isPopupCall: boolean = true;
  saveAccountDetails: Subject<boolean> = new Subject();
  successcommon: boolean = false;
  successHeader: string = "Account Details";
  successMessage: string = "";
  constructor() { }

  ngOnInit() {
  }
  onClose() {
    this.displayChange.emit(false);
  }
  onSave(){
    this.displayChange.emit(true);
    this.saveAccountDetails.next(true);
  }
  onSaveData(ev){
    if(ev){
      this.showAccount = false;
      this.displayChange.emit(true);    
      this.successcommon = true;
      this.successMessage = "Account details has been updated successfully."
    }else{
      this.showAccount = false;
      this.displayChange.emit(true);      
    }
  }
  onSuccesscommonClose(ev){
    this.successcommon =false;
  }
}
